SlideView = require("views/slide")
device    = require("lib/device")

class ScrollableView extends SlideView
  template: require("./template")
  ignoreStateOnRefresh: true

  buffer: 40

  events: ->
    "iostap .btn-done": "submit"

  serialize: ->
    data = super
    data.hasPrompt = true
    data

  beforeShow: ->
    @trigger("ui", flexibleHeight: true)

  beforeHide: ->
    @trigger("ui", flexibleHeight: false)

  show: ->
    @setHeight()
    @listenTo this, "resize", @onResize

  onScroll: (e) ->
    super

    if e.currentTarget.scrollTop >= @scrollLimit
      @setState("touched")

  onResize: ->
    @setHeight()

  setHeight: (narrationIsComplete, y) ->
    el = @findOne(".content-scroll")

    el.scrollTop = y if y?

    outerHeight  = @el.offsetHeight
    innerHeight  = el.firstChild.offsetHeight
    @scrollLimit = innerHeight - outerHeight - @buffer

    hasNarration =
      not narrationIsComplete and
      @options.data.narration?.audio_file and
      @options.data.narration?.can_not_be_skipped

    if innerHeight - @buffer <= outerHeight
      @setState("touched") unless hasNarration
      @transform el.firstChild, y: (outerHeight - (innerHeight - @buffer)) / 2

    else
      @transform el.firstChild,
        y: 0, transition: "all 300ms"

      @setState("prompt") unless hasNarration

    if el.scrollTop >= @scrollLimit
      @setState("prompt") unless hasNarration
      @setState("touched") unless hasNarration

    if el.offsetHeight < el.scrollHeight and device.platform is "iOS"
      # This fix is for older iPads, which fail to calculate
      # the scrollable area of the content correctly. See #652.
      el.style.paddingBottom = "2px"
      el.scrollTop = 1
      window.setTimeout ->
        el.offsetTop
        el.scrollTop = 0
        el.style.paddingBottom = ""
      , 10


  refresh: ->
    scroller  = @findOne(".content-scroll")
    scrollTop = scroller.scrollTop

    super

    @setHeight(false, scrollTop)

  onNarrationPause: ->
    @setHeight()

  onNarrationComplete: ->
    @setHeight(true)

module.exports = ScrollableView
